import React from 'react';
import PropTypes from 'prop-types';
import ChunkPickerDoublePageButton from './ChunkPickerDoublePageButton';

import './ChunkPickerDoublePage.scss';

function ChunkPickerDoublePage(props) {
  const { children, ...rest } = props;

  return (
    <div className="chunk-picker-double-page">
      <ChunkPickerDoublePageButton {...rest} iconClassName="left" />
      <div className="chunk-picker-double-page-title">{children}</div>
      <ChunkPickerDoublePageButton {...rest} iconClassName="right" />
    </div>
  );
}

ChunkPickerDoublePage.propTypes = {
  children: PropTypes.node,
};

export default ChunkPickerDoublePage;
